import {
  Component, OnInit, ViewChild, OnDestroy,
  ElementRef, AfterViewInit, ChangeDetectorRef, HostListener
} from '@angular/core';
import {getMenuRoutes} from './vertical-menu-routes.config';
import {HROUTES} from '../horizontal-menu/navigation-routes.config';

import {Router} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import {customAnimations} from '../animations/custom-animations';
import {DeviceDetectorService} from 'ngx-device-detector';
import {ConfigService} from '../services/config.service';
import {Subscription} from 'rxjs';
import {LayoutService} from '../services/layout.service';
import {PermissionsService} from '../api/permissions/permissions.service';
import {AuthService} from '../auth/auth.service';
import {RouteInfo} from './vertical-menu.metadata';

@Component({
  selector: 'app-sidebar',
  templateUrl: './vertical-menu.component.html',
  styleUrls: ['./vertical-menu.component.scss'],
  animations: customAnimations
})
export class VerticalMenuComponent implements OnInit, AfterViewInit, OnDestroy {

  @ViewChild('toggleIcon') toggleIcon: ElementRef;
  public menuItems: any[];
  level = 0;
  logoUrl = '';
  public config: any = {};
  protected innerWidth: any;
  layoutSub: Subscription;
  configSub: Subscription;
  perfectScrollbarEnable = true;
  collapseSidebar = false;
  resizeTimeout;

  constructor(
    private router: Router,
    public translate: TranslateService,
    private layoutService: LayoutService,
    private configService: ConfigService,
    private cdr: ChangeDetectorRef,
    private deviceService: DeviceDetectorService,
    private permissions: PermissionsService,
    private authService: AuthService
  ) {
    this.config = this.configService.templateConf;
    this.innerWidth = window.innerWidth;
    this.isTouchDevice();
  }


  ngOnInit(): void {
    this.menuItems = this.processRoutesPermissions(getMenuRoutes(this.authService.panelType));
  }

  processRoutesPermissions(routesParam: RouteInfo[]): RouteInfo[] {
    const routes = [];
    // Se comprueban los permisos

    for (const route of routesParam) {

      const hasChilds = route.cssClass.includes('has-sub');
      // Si tiene hijos se verifican los premisos de los hijos
      if (hasChilds) {
        route.submenu = this.processRoutesPermissions(route.submenu);
      }

      if ((hasChilds && route.submenu.length > 0) ||
        route.isExternalLink ||
        (!hasChilds && this.permissions.pathPermission(route.path.replace('/app/', '')))
      ) {
        routes.push(route);
      }
    }

    return routes;
  }

  ngAfterViewInit(): void {

    this.configSub = this.configService.templateConf$.subscribe((templateConf) => {
      if (templateConf) {
        this.config = templateConf;
      }
      this.loadLayout();
      this.cdr.markForCheck();

    });

    this.layoutSub = this.layoutService.overlaySidebarToggle$.subscribe(
      collapse => {
        if (this.config.layout.menuPosition === 'Side') {
          this.collapseSidebar = collapse;
        }
      });

  }


  @HostListener('window:resize', ['$event'])
  onWindowResize(event): void {
    if (this.resizeTimeout) {
      clearTimeout(this.resizeTimeout);
    }
    this.resizeTimeout = setTimeout((() => {
      this.innerWidth = event.target.innerWidth;
      this.loadLayout();
    }).bind(this), 500);
  }

  loadLayout(): void {

    if (this.config.layout.menuPosition === 'Top') { // Horizontal Menu
      if (this.innerWidth < 1200) { // Screen size < 1200
        this.menuItems = this.processRoutesPermissions(HROUTES);
      }
    } else if (this.config.layout.menuPosition === 'Side') { // Vertical Menu{
      this.menuItems = this.processRoutesPermissions(getMenuRoutes(this.authService.panelType));
    }


    let logotype = '';
    if (['admin', 'doctor'].includes(this.authService.panelType)) {
      logotype = '-' + this.authService.panelType;
    }


    if (this.config.layout.sidebar.backgroundColor === 'white') {
      this.logoUrl = 'assets/img/logos/full-layout' + logotype + '-dark.png';
    } else {
      this.logoUrl = 'assets/img/logos/full-layout' + logotype + '.png';
    }

    this.collapseSidebar = !!this.config.layout.sidebar.collapsed;
  }

  toggleSidebar(): void {
    const conf = this.config;
    conf.layout.sidebar.collapsed = !this.config.layout.sidebar.collapsed;
    this.configService.applyTemplateConfigChange({layout: conf.layout});

    setTimeout(() => {
      this.fireRefreshEventOnWindow();
    }, 300);
  }

  fireRefreshEventOnWindow = () => {
    const evt = document.createEvent('HTMLEvents');
    evt.initEvent('resize', true, false);
    window.dispatchEvent(evt);
  }

  CloseSidebar(): void {
    this.layoutService.toggleSidebarSmallScreen(false);
  }

  isTouchDevice(): void {

    const isMobile = this.deviceService.isMobile();
    const isTablet = this.deviceService.isTablet();

    this.perfectScrollbarEnable = !(isMobile || isTablet);

  }


  ngOnDestroy(): void {
    if (this.layoutSub) {
      this.layoutSub.unsubscribe();
    }
    if (this.configSub) {
      this.configSub.unsubscribe();
    }

  }

}
